import styled from 'styled-components';

import { Button, devices, Paragraph } from '@/UI';

export const Arrow = styled.img`
  bottom: 140px;
  display: none;
  height: 100px;
  left: -40px;
  position: absolute;
  width: 100px;

  @media ${devices.Medium} {
    display: block;
  }

  @media ${devices.Large} {
    width: 150px;
  }
`;

export const Nav = styled.nav`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 25px;

  @media ${devices.Medium} {
    justify-content: flex-end;
  }
`;

export const Body = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 59px);
  padding: 0 15px;
`;

export const Container = styled.div`
  width: 100%;

  @media ${devices.Medium} {
    align-items: flex-end;
    column-gap: 50px;
    display: flex;
    justify-content: center;
  }
`;

export const Left = styled.div`
  margin-bottom: 40px;
  text-align: center;

  @media ${devices.Medium} {
    margin-bottom: 0;
    width: 60%;
  }
`;

export const Right = styled.div`
  @media ${devices.Medium} {
    position: relative;
    top: -100px;
  }
`;

export const Imgage = styled.img`
  height: auto;
  max-width: 300px;
  width: 100%;

  @media ${devices.Medium} {
    max-width: 100%;
  }
`;

export const Title = styled(Paragraph)`
  color: ${({ theme }) => theme.palette.secondary};
  margin-bottom: 12px;
  text-align: center;
`;

export const Text = styled(Paragraph)`
  color: ${({ theme }) => theme.palette.grays80};
  font-weight: 400;
  margin-bottom: 30px;
  text-align: center;

  @media ${devices.Medium} {
    font-weight: 500;
    padding: 0px;
  }
`;

export const StyledButton = styled(Button)`
  margin: auto;
  padding-left: 25px;
  padding-right: 25px;
`;
